import { ViewSectionType } from "../../../module-selector/types/ViewSectionType";
import { ModuleType } from "../../../module-selector/types/ModuleType";
import { Stack } from "@mui/material";
import OptionsTablePage from "../../../options-table/containers/OptionsTablePage";
import {
    PortfolioBalanceProfile
} from "../../../portfolio-profile/components/charts/portfolio-balance-profile/PortfolioBalanceProfile";
import {
    PortfolioGreekProfile
} from "../../../portfolio-profile/components/charts/portfolio-greek-profile/PortfolioGreekProfile";
import { PortfolioBalancerView } from "../../../portfolio-info/views/portfolio-balancer-view/PortfolioBalancerView";
import { PortfolioBalanceHistory } from "../../../portfolio-balance-history/components/PortfolioBalanceHistory";
import { PositionsAndOrders } from "../../../positions-and-orders/PositionsAndOrders";
import { Binance } from "../../../binance/Binance";

export function ViewSection({
    viewSectionType,
    activeViewSectionType,
    activeViewSectionModuleType,
    setActiveViewSection
}: {
    viewSectionType: ViewSectionType;
    activeViewSectionType: ViewSectionType;
    activeViewSectionModuleType: ModuleType;
    setActiveViewSection: React.Dispatch<React.SetStateAction<ViewSectionType>>;
}) {
    const activeViewBorderColour = '#22293A';
    const viewBorderColour = '#c2c2c2';
    const viewBorderWidth = '3px';

    return (
        <Stack
            direction="column"
            spacing={0}
            sx={{
                margin: '1px',
                padding: '5px',
                width: '49.8vw',
                overflow: 'auto',
                border: activeViewSectionType === viewSectionType
                    ? `${viewBorderWidth} solid ${activeViewBorderColour}`
                    : `${viewBorderWidth} solid ${viewBorderColour}`,
            }}
            onClick={() => setActiveViewSection(viewSectionType)}
        >
            {GetModule(activeViewSectionModuleType)}
        </Stack>
    );
}

function GetModule(moduleType: ModuleType): JSX.Element | null {
    switch (moduleType) {
        case ModuleType.OptionsTable:
            return <OptionsTablePage/>;
        case ModuleType.PositionsAndOrders:
            return <PositionsAndOrders/>;
        case ModuleType.Binance:
            return <Binance/>;
        case ModuleType.BalanceProfile:
            return <PortfolioBalanceProfile fullSize={false}/>;
        case ModuleType.ParametersProfile:
            return <PortfolioGreekProfile/>
        case ModuleType.PortfolioBalancer:
            return <PortfolioBalancerView/>;
        case ModuleType.BalanceHistory:
            return <PortfolioBalanceHistory/>;

        default:
            return <b>The module {moduleType} isn't implemented yet!</b>;
    }
}